import { useQuery } from "@tanstack/react-query";
import { fetchRedemptions } from "@/api/reportsRedemptions";
import type { RedemptionsListParams } from "@/interfaces/reportsRedemptions";

/** Query key root for the Redemptions report list — other units invalidate/prefetch against it. */
export const REDEMPTIONS_QUERY_KEY = ["reports", "redemptions"] as const;

/**
 * GET /reports/redemptions, keyed by every param so distinct searches/filters/sorts/pages cache
 * independently. `enabled` lets the page hold the request while permissions are still loading.
 */
export function useReportsRedemptions(
  params?: RedemptionsListParams,
  options?: { enabled?: boolean },
) {
  return useQuery({
    queryKey: [...REDEMPTIONS_QUERY_KEY, "list", params],
    queryFn: () => fetchRedemptions(params),
    enabled: options?.enabled,
  });
}
